<template>
  <v-data-table
    :headers="headers"
    :loading="!!!services"
    :items="services"
    :items-per-page="10"
    :search="search"
    :sort-by="['name']"
  >
    <template v-slot:top>
      <v-text-field
        v-model="search"
        :label="$t('DATA_TABLE.SEARCH')"
        outlined
        append-icon="mdi-magnify"
      ></v-text-field>
    </template>

    <template v-slot:item.action="{ item }">
      <action-slot-component
        :item="item"
        :route-name="routeName(item)"
        :route-params="{ id: item.id }"
        @show="$emit('show', item)"
      />
    </template>

    <template v-slot:item.price="{ item }">
      {{ formatPrice(item) }}
    </template>
  </v-data-table>
</template>

<script>
import moment from 'moment';
import ActionSlotComponent from '@/modules/_global/_components/ActionSlotComponent.vue';

export default {
  name: 'Services',
  components: { ActionSlotComponent },

  filters: {
    created_at(value) {
      if (!value) return 'no value';

      return moment(value).fromNow();
    }
  },

  data: () => ({
    search: '',
    unwatch: null,
    filter: {
      name: '',
      description: ''
    }
  }),

  computed: {
    services() {
      return this.$store.getters['service/RETRIEVED_SERVICES'];
    },

    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.TITLE'),
          value: 'title'
        },
        {
          text: this.$t('SERVICES.NAME_IN_THE_APP'),
          value: 'name'
        },
        {
          text: this.$t('ITEM.TYPE'),
          value: 'type'
        },
        {
          text: this.$t('ITEM.GROUP'),
          value: 'group'
        },
        {
          text: this.$t('ITEM.PRICE'),
          value: 'price'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          align: 'center'
        }
      ];
    }
  },

  created() {
    this.setData();
    this.unwatch = this.$store.watch(
      state => state.localization.lang,
      () => {
        const lang = this.$store.state.localization.lang;

        if (lang) {
          this.setData();
        }
      }
    );
  },

  destroyed() {
    this.unwatch();
  },

  methods: {
    formatPrice(item) {
      if (item.is_on_request) {
        return this.$t('ITEM.ON_REQUEST');
      } else if (!item.price && item.price !== 0) {
        return this.$t('ITEM.EMPTY');
      } else {
        return item.price;
      }
    },
    setData() {
      this.$store.dispatch('service/retrieveServices').then(({ data }) => {
        this.$store.commit('service/retrievedServices', data);
      });
    },

    routeName(item) {
      if (item.type_id === 2) {
        return 'customer-service.show';
      } else if (item.type_id === 3) {
        return 'internal-service.show';
      }
      return 'internal-service.show';
    }
  }
};
</script>
